import $ from "jquery";

$(document).ready(helpShiftContentPadding);
$(window).resize(helpShiftContentPadding);

function helpShiftContentPadding() {
    const helpShiftContent = $('.help-shift-content');

    if (helpShiftContent.length === 0) {
        return;
    }

    const header = $('.help-shift-header');
    const nav = $('.help-shift-nav');

    let helpShiftPadding = header.height() + nav.height();

    helpShiftContent.css('padding-top', helpShiftPadding);
}
